/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import PropTypes from 'prop-types';

import React from 'react';
import moment from 'moment';
import TextField from 'material-ui/TextField';
import { localize } from '../i18n';

const VALID_IMAGE_EXTENSIONS = [
  'png', 'jpg', 'jpeg', 'gif', 'svg',
];

const Comment = function Comment(props) {
  const {
    editable,
    showDelete,
    comment,
    onChange,
    onDelete,
    onShowModal,
    addModalControl,
    className,
  } = props;
  let attachmentPreview = null;
  let commentText = comment.text;
  const metaDataInfo = [];

  if (comment.has_attachment === true) {
    let attachmentSize = Math.ceil(comment.attachment_size / 1024);
    let attachmentSizeType = 'KB';
    if (attachmentSize > 1024) {
      attachmentSize = Math.ceil(attachmentSize / 1024);
      attachmentSizeType = 'MB';
    }
    let attachmentFile = (
      <i className="material-icons md-64 uk-text-muted">&#xE24D;</i>
    );
    const attachmentNameParts = comment.attachment_name.split('.');
    if (attachmentNameParts.length > 1 && VALID_IMAGE_EXTENSIONS.indexOf(attachmentNameParts.slice(-1)[0].toLowerCase()) !== -1) {
      const src = comment.attachment_url;
      const alt = comment.attachment_name;
      const caption = (
        <div className="dont-break-out">
          <div className="uk-text-small uk-text-center">{comment.attachment_name}</div>
          <div className="uk-text-small uk-text-center">{attachmentSize} {attachmentSizeType}</div>
        </div>
      );
      attachmentFile = (
        <img src={comment.attachment_url} alt={comment.attachment_name} />
      );
      if (addModalControl === true) {
        const originalAttachmentFile = attachmentFile;
        attachmentFile = (
          <a
            href={`#lightbox-${comment.attachment_name.replace(/\W+/g, '-')}`}
            onClick={() => {
              onShowModal({
                src,
                alt,
                caption,
              });
            }}
          >
            {originalAttachmentFile}
          </a>
        );
      }
    }
    let attachmentName = comment.attachment_name;
    const attachmentNameLength = attachmentName.length;
    if (attachmentNameLength > 18) {
      attachmentName = `${comment.attachment_name.substring(0, 7)}...${comment.attachment_name.substring((attachmentNameLength - 8), attachmentNameLength)}`;
    }
    attachmentPreview = (
      <div className="attachment-info">
        <div className="attachment-thumbnail">
          {attachmentFile}
        </div>
        <div className="uk-text-small uk-text-center">{attachmentName}</div>
        <div className="uk-text-small uk-text-center">{attachmentSize} {attachmentSizeType}</div>
      </div>
    );
  }

  if (editable === true) {
    commentText = (
      <TextField
        name={`attachment-${comment.attachment_name}`}
        value={comment.text}
        hintStyle={{ fontSize: 14 }}
        fullWidth
        onChange={evt => onChange(evt, evt.target.value)}
      />
    );
  }

  if (showDelete === true) {
    const originalAttachmentPreview = attachmentPreview;
    attachmentPreview = (
      <div className="uk-grid">
        <div className="uk-width-small-7-10 uk-width-mobile-7-10">
          {originalAttachmentPreview}
        </div>
        <div className="uk-width-small-1-10 uk-width-mobile-1-10">
          <a
            href={`#delete-attachment-${comment.attachment_name}`}
            onClick={() => onDelete()}
            className="delete-button"
          >
            <i className="md-icon material-icons md-icon-danger">&#xE5CD;</i>
          </a>
        </div>
      </div>
    );
  }

  if (comment._created) {
    if (comment._created === 'pending') {
      metaDataInfo.push((
        <span key="created" className="uk-margin-right">
          <i className="material-icons">&#xE192;</i> <span className="uk-text-muted uk-text-small">{props.t('Pending')}...</span>
        </span>
      ));
    } else {
      metaDataInfo.push((
        <span key="created" className="uk-margin-right">
          <i className="material-icons">&#xE192;</i> <span className="uk-text-muted uk-text-small">{moment(comment._created).fromNow()}</span>
        </span>
      ));
    }
  }

  if (comment.created_by) {
    metaDataInfo.push((
      <span key="user" className="uk-margin-right">
        <i className="material-icons">&#xE7FF;</i> <span className="uk-text-muted uk-text-small">{comment.created_by.full_name}</span>
      </span>
    ));
  }

  return (
    <li className={className}>
      <div className="uk-grid">
        <div className="uk-width-medium-7-10 uk-width-small-3-4 uk-width-mobile-3-5">
          {commentText}
          {(metaDataInfo.length > 0) ? (
            <div className="uk-margin-small-top">
              {metaDataInfo}
            </div>
          ) : null}
        </div>
        <div className="uk-width-medium-3-10 uk-width-small-1-4 uk-width-mobile-2-5">
          {attachmentPreview}
        </div>
      </div>
    </li>
  );
};

Comment.propTypes = {
  className: PropTypes.string,
  editable: PropTypes.bool.isRequired,
  showDelete: PropTypes.bool,
  addModalControl: PropTypes.bool,
  comment: PropTypes.shape({
    attachment_size: PropTypes.number,
    attachment_name: PropTypes.string,
    attachment_url: PropTypes.string,
    text: PropTypes.string,
    has_attachment: PropTypes.bool,
    _created: PropTypes.string,
    created_by: PropTypes.shape({
      full_name: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  onShowModal: PropTypes.func,
  t: PropTypes.func.isRequired,
};

Comment.defaultProps = {
  className: '',
  editable: false,
  showDelete: false,
  onChange: () => {},
  onDelete: () => {},
  addModalControl: false,
  onShowModal: () => {},
};

export default localize(Comment);



// WEBPACK FOOTER //
// ./src/components/Comment.js